// NewFolder.js
import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Backdrop,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Container,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Check from "@material-ui/icons/Check";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AddIcon from "@material-ui/icons/Add";
import DocuwareTemplateService from "../../../services/DocuwareTemplateService";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import notify from "../../../utils/notifier"; // keep if you have this utility
import MultiSelectWithSelectAll from "./MultiSelectComponent";
import DateRangeSelector from "./DateRangeSelector";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";



const useStyles = makeStyles((theme) => ({
  pageWrapper: {
    backgroundColor: "#F5F3F5",
    minHeight: "100vh",
    width: "calc(100% + 48px)",
    margin: "-24px",
    padding: "24px",
  },
  rootPaper: {
    borderRadius: 2,
    overflow: "hidden", // ensures rounded corners
    paddingTop : 0,
    paddingBottom: 80,
    fontFamily: '"Montserrat", sans-serif !important',
    '& *': {
      fontFamily: '"Montserrat", sans-serif !important',
    }
  },
  backButton:{
    padding: 0,
    minWidth: 'auto',
    fontSize: '0.8rem',
    textTransform: 'none',
    fontFamily: '"Montserrat", sans-serif !important',
    marginBottom: '12px'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    mb: 2 
  },
  title:{
    fontFamily: '"Montserrat", sans-serif !important', 
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '32px'
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  stepperBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  customStepper: {
    backgroundColor: "transparent",
    width: "100%",
    justifyContent: "space-between", 
  },
  stepIconRoot: {
    color: "#ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    width: 20,
    height: 20,
    border: "2px solid #ccc",
  },
  active: {
    color: "#1976d2",
    borderColor: "#00445D",
  },
  completed: {
    color: "#fff",
    backgroundColor: "#00445D",
    borderColor: "#00445D",
  },
  incomplete: {
    background: "linear-gradient(to right, #00445D 50%, transparent 50%)",
    borderColor: "#00445D",
  },
  formSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    background: "#fff",
    borderRadius: 6,
  },
  rulesBox: {
    marginTop: theme.spacing(2),
    // background: "#e9f3f7",
    padding: theme.spacing(2),
    borderRadius: 6,
  },
  ruleRow: {
    display: "flex",
    alignItems: "center",
    background: "#E3F2FD",
    // width: 1276,
    height: '9%',
    gap: 24,
    borderRadius: 8,
    padding: '12px 24px',
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    position: "fixed",
    bottom: 0,
    left: 75,
    right: 0,
    backgroundColor: "#FFFFFF",
    padding: "16px 24px",
    borderTop: "1px solid #E5E7EB",
    zIndex: 1000,
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)",
  },
  smallButton: {
    borderRadius: 20,
    minWidth: 120,
  },
  actionButton: {
    borderRadius: 20,
    minWidth: 120,
    marginLeft: 260,
    marginRight: 10,
    backgroundColor: "#00445D",
    color: "#fff",
  },
  tablePlaceholder: {
    height: 140,
    background: "#f6f6f6",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#777",
  },
  sectionTitle: {
    fontFamily: '"Montserrat", sans-serif !important',
    fontWeight: '700 !important',
    fontSize: '20px !important',
    marginBottom: theme.spacing(1),
  },

  sectionHeader: {
    fontFamily: '"Montserrat", sans-serif !important',
    fontWeight: '700 !important',
    fontSize: '24px !important',
    color: '#000',
  },

  sectionTitle2: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },

  labelAbove: {
    fontWeight: 500,
    fontSize: '12px',
    marginBottom: theme.spacing(0.5),
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginBottom: "30px"
  },
  boldCell:{
    fontFamily: '"Montserrat", sans-serif !important',
    fontWeight: '600 !important',
    fontSize: '14px !important',
    color: 'black',
    textAlign: 'left',
    paddingTop: 0.5, 
    paddingBottom: 0.5,
    borderBottom: '1px solid #6E6E72 !important'
  },

  cell:{
    fontSize: '14px',
    color: '#1E1450',
    textAlign: 'left',
    paddingTop: 0.5, paddingBottom: 0.5 
  },

  whiteRow:{
    backgroundColor: '#fff',
    height:'30px'
  },

  coloredRow:{
    backgroundColor: '#F9FCFF',
    height:'30px'
  },

  table:{
    '& .MuiTableRow-root': {
        height: '40px',
    }
  },

  fieldGroup: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  checkboxLabel: {
    color: '#0F0F19',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
  },
  // Error Dialog styles
  errorDialogPaper: {
    borderRadius: 8,
  },
  errorDialogTitle: {
    padding: "20px 24px 16px 24px",
  },
  errorDialogTitleContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  errorDialogTitleLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  errorDialogIcon: {
    color: "#00445D",
    fontSize: 24,
  },
  errorDialogTitleText: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
    fontSize: 20,
    color: '#0F0F19',
  },
  errorDialogContent: {
    padding: "0 24px 24px 24px",
  },
  errorDialogMessageBox: {
    backgroundColor: "#E8F4F8",
    borderLeft: "4px solid #99CCDF",
    padding: "16px 20px",
    borderRadius: "0 4px 4px 0",
  },
  errorDialogMessage: {
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 600,
    fontSize: 14,
    color: "#0F0F19",
    marginBottom: 4,
  },
  errorDialogSubMessage: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: 14,
    color: "#666",
  },
  errorDialogActions: {
    padding: "0 24px 24px 24px",
    justifyContent: "flex-end",
  },
  errorDialogButton: {
    backgroundColor: "#00445D",
    color: "#fff",
    fontFamily: '"Montserrat", sans-serif',
    textTransform: "none",
    borderRadius: 20,
    padding: "8px 32px",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#003347",
    },
  },
}));

const CustomStepIcon = (props) => {
  const classes = useStyles();
  const { active, completed, incomplete } = props;

  // Priority: completed > incomplete > active > pending
  // incomplete = current step + user made changes (shows half-filled)
  let stateClass = "";
  if (completed) {
    stateClass = classes.completed;
  } else if (incomplete) {
    stateClass = classes.incomplete;
  } else if (active) {
    stateClass = classes.active;
  }

  return (
    <div className={`${classes.stepIconRoot} ${stateClass}`}>
      {completed ? <Check fontSize="small" /> : null}
    </div>
  );
};

const steps = [
  "Folder Config",
  "Mandatory Fields",
  "Advanced (optional)",
  "Review & Submit",
];

export default function NewFolder(props) {
  const classes = useStyles();

  // Form state
  const [activeStep, setActiveStep] = useState(0);
  const [touchedSteps, setTouchedSteps] = useState({});
  const [backdrop, setBackdrop] = useState(false);

  // Error dialog state
  const [errorDialog, setErrorDialog] = useState({
    open: false,
    title: "",
    message: "",
    subMessage: ""
  });

  const showErrorDialog = (title, message, subMessage = "") => {
    setErrorDialog({ open: true, title, message, subMessage });
  };

  const closeErrorDialog = () => {
    setErrorDialog({ ...errorDialog, open: false });
  };

  // Mark current step as touched when user interacts
  const markCurrentStepTouched = () => {
    setTouchedSteps(prev => ({ ...prev, [activeStep]: true }));
  };

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  // Folder rules (each rule: { field, constraintType, acceptableValue })
  const [newRuleField, setNewRuleField] = useState("");
  const [newRuleConstraint, setNewRuleConstraint] = useState("");
  const [newRuleAcceptable, setNewRuleAcceptable] = useState("");
  const [rules, setRules] = useState([]);
  const [clientFields, setClientFields] = useState([]);
  const [availableFields2, setAvailableFields] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [enableRename, setEnableRename] = useState(true);
  const [additionalFields, setAdditionalFields] = useState({
    field1: "",
    field2: "",
    field3: "",
    field4: "",
    field5: "",
    connector: "-",
    expiry: "",
  });
  
  // Scanning rules state
  const [scanForDuplicates, setScanForDuplicates] = useState(false);
  const [scanForSameName, setScanForSameName] = useState(false);
  const [scanForAntivirus, setScanForAntivirus] = useState(true);
  
  // Document sharing state
  const [shareLinkExpiryMinutes, setShareLinkExpiryMinutes] = useState(60);
  
  const history = useHistory();

  let systemFields = [{
    "name": "name",
    "type": "string",
    "autoPopulate": true,
    "isSearchable": true
  },
  {
    "name": "document_category",
    "type": "string",
    "autoPopulate": true,
    "isSearchable": true
  }]

  const handleHomeClick = () => {
    history.push('/document-suite/configurations/storage');
  };

  // Filter fields by search
  const filteredFields = clientFields.filter((field) =>
    field.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCheckboxChange = (fieldName) => {
    setMandatoryFields((prev) =>
      prev.includes(fieldName)
        ? prev.filter((f) => f !== fieldName)
        : [...prev, fieldName]
    );
    markCurrentStepTouched();
  };

  const handleToggleRename = (e) => {
    setEnableRename(e.target.checked);
    markCurrentStepTouched();
    if (!e.target.checked) {
      // Optionally clear fields when disabled
      ["field1", "field2", "field3", "field4", "field5", "connector"].forEach((key) =>
        handleChange(key, "")
      );
    }
  };

  

  // Format acceptable value for display (handles date ranges)
  const formatAcceptableValue = (value) => {
    // Check if it's a date range (array of two ISO date strings)
    if (Array.isArray(value) && value.length === 2) {
      const isDateRange = value.every(v => 
        typeof v === 'string' && !isNaN(Date.parse(v)) && v.includes('T')
      );
      if (isDateRange) {
        const startDate = dayjs(value[0]).format("DD/MM/YYYY");
        const endDate = dayjs(value[1]).format("DD/MM/YYYY");
        return `${startDate} - ${endDate}`;
      }
    }
    // For other values, stringify if needed
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value;
  };

  const handleChange = (key, value) => {
    setAdditionalFields((prev) => ({ ...prev, [key]: value }));
    markCurrentStepTouched();
  };

  const constraintTypes = ["Equals", "Not Equals", "Body Range", "Includes", "Excludes", "Starts With"];

  const constraintMap = {
    "Equals" :  '=',
    "Not Equals" : '!=',
    "Body Range":  'between',
    "Includes": 'in',
    "Excludes": 'not_in',
    "Starts With" : 'startsWith'
  }

  const isNameValid = () => name && name.trim().length > 0;

  // Step navigation
  const handleNext = () => {
    // Simple validation: Name required on first step
    if (activeStep === 0 && !isNameValid()) {
      notify && notify({ type: "error", message: "Name is required" });
      return;
    }
    // simulate some processing
    setBackdrop(true);
    setTimeout(() => {
      setBackdrop(false);
      setActiveStep((prev) => prev + 1);
    }, 250);
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const handleAddRule = () => {
    if (
      !newRuleField ||
      newRuleField === "Select Field" ||
      !newRuleConstraint ||
      !newRuleAcceptable
    ) {
      notify && notify({ type: "error", message: "Please fill rule fields" });
      return;
    }

    setRules((prev) => [
      ...prev,
      {
        id: Date.now(),
        field: newRuleField,
        constraintType: newRuleConstraint,
        acceptableValue: newRuleAcceptable,
      },
    ]);
    // reset new rule inputs
    setNewRuleField("Select Field");
    setNewRuleConstraint("");
    setNewRuleAcceptable("");
  };

  const handleRemoveRule = (id) => {
    setRules((prev) => prev.filter((r) => r.id !== id));
  };

  const handleSubmit = () => {
    const payload = {
      name,
      description
    };

    let ruleConfig = [];

    for (let rule of rules){
      let x = {};
      x["field"] = rule.field;
      x["operator"] = constraintMap[rule.constraintType];
      x["value"] = rule.acceptableValue;
      ruleConfig.push(x);
    }

    if (ruleConfig.length>0){
      payload.ruleConfig = ruleConfig;
    }

    let config = {};

    let fields = ['field1', 'field2', 'field3', 'field4', 'field5']
    let renameFields = [];
    for (let field of fields){
      if (additionalFields[field]!=''){
        renameFields.push(additionalFields[field]);
      }
    }
    
    if (renameFields.length>0){
      config.renameFields = renameFields;
      config.connector = additionalFields.connector;
    }

    if (additionalFields.expiry && additionalFields.expiry!=''){
      config.expiryTime = additionalFields.expiry;
    }

    // Add scanning rules
    config.scanForDuplicates = scanForDuplicates;
    config.scanForSameName = scanForSameName;
    
    // Add document sharing settings
    config.shareLinkExpiryMinutes = shareLinkExpiryMinutes;

    payload.config = config;

    if (mandatoryFields.length>0){
      let fields = [];
      for (let field of mandatoryFields){
        fields.push({"name":field, "type":"string"});
      }
      payload.fields = fields;
    }
    setBackdrop(true);
    DocuwareTemplateService.createTemplate(payload).then(response => {
      notify({ type: "success", message: "Folder created successfully" });
      handleHomeClick();
      setBackdrop(false);

    }).catch(error => {
      showErrorDialog(
        "Incomplete submission",
        "Cannot proceed without mandatory inputs",
        "Please fill the form completely before submitting the changes."
      );
      setBackdrop(false);
    })
  };

  // Render step contents
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>

            <Box
                sx={{
                  backgroundColor: "#99CCDF",
                  padding: "8px 16px",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
              <Typography
                variant="h5"
                className={classes.sectionHeader}
              >
                Details
              </Typography>
            </Box>
            <div style={{padding: 20}}>
            <Typography className={classes.sectionTitle} variant="h6">
              Basic Details
            </Typography>

            <Box className={classes.fieldContainer}>
              <Box>
                <Typography className={classes.labelAbove}>Name*</Typography>
                <TextField value={name} variant="outlined" size="small" style={{ width: "350px" }} onChange={(e) => { setName(e.target.value); markCurrentStepTouched(); }} />
              </Box>

              <Box>
                <Typography className={classes.labelAbove}>Description</Typography>
                <TextField value={description} fullWidth variant="outlined" size="small" onChange={(e) => { setDescription(e.target.value); markCurrentStepTouched(); }}/>
              </Box>
            </Box>


            <Typography className={classes.sectionTitle} variant="h6">
                Folder Rules
            </Typography>

            <Box className={classes.rulesBox}>
              <Box className={classes.ruleRow}>
                <Box>
                <Typography className={classes.labelAbove}>Field</Typography>
                
                <Autocomplete
                  options={[...clientFields, ...systemFields]}
                  getOptionLabel={(option) => option.name}
                  value={clientFields.find((f) => f.name === newRuleField) || systemFields.find((f) => f.name === newRuleField) || null}
                  onChange={(event, newValue) => { setNewRuleField(newValue ? newValue.name : ""); markCurrentStepTouched(); }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      placeholder="Select Field"
                      style={{
                        "& .MuiOutlinedInput-root": { height: 40, width : 500 },
                      }}
                    />
                  )}
                  style={{width: 350}}
                />
                </Box>

                <Box>
                  <Typography className={classes.labelAbove}>Constraint Type</Typography>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: 350,
                      "& .MuiOutlinedInput-root": { height: 40 , width : 100},
                    }}
                  >
                    <Select
                      value={newRuleConstraint}
                      onChange={(e) => { setNewRuleConstraint(e.target.value); markCurrentStepTouched(); }}
                      placeholder="None"
                      displayEmpty
                    >
                      {constraintTypes.map((c) => (
                        <MenuItem key={c} value={c}>
                          {c}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>


                <Box>
                  <Typography className={classes.labelAbove}>Acceptable Value</Typography>
                  {(newRuleField != '' && newRuleConstraint != '') ? 
                    clientFields.find((f) => f.name === newRuleField) &&clientFields.find((f) => f.name === newRuleField).acceptedValues ? 
                      (newRuleConstraint == 'Includes' || newRuleConstraint =='Excludes') ? 
                          <MultiSelectWithSelectAll
                            clientFields={clientFields}
                            newRuleField={newRuleField}
                            newRuleAcceptable={newRuleAcceptable}
                            setNewRuleAcceptable={setNewRuleAcceptable}
                          />
                      :
                      <FormControl
                          variant="outlined"
                          size="small"
                          style={{
                            width: 350,
                            "& .MuiOutlinedInput-root": { height: 40 , width : 100},
                          }}
                        >
                          <Select
                            value={newRuleAcceptable}
                            onChange={(e) => { setNewRuleAcceptable(e.target.value); markCurrentStepTouched(); }}
                            placeholder="None"
                            displayEmpty
                          >
                            {clientFields.find((f) => f.name === newRuleField).acceptedValues.map((c) => (
                              <MenuItem key={c} value={c}>
                                {c}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                    : (clientFields.find((f) => f.name === newRuleField) &&clientFields.find((f) => f.name === newRuleField).type=='timestamp') ? 
                        <DateRangeSelector
                          newRuleAcceptable={newRuleAcceptable}
                          setNewRuleAcceptable={setNewRuleAcceptable}
                        />
                    : <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Select accepted values"
                    onChange={(e) => { setNewRuleAcceptable(e.target.value); markCurrentStepTouched(); }}
                    style={{
                      width:350,
                      "& .MuiOutlinedInput-root": { height: 40, width : 500 },
                    }}
                  />
                 : <TextField
                 disabled
                 variant="outlined"
                 size="small"
                 placeholder="Select accepted values"
                 onChange={(e) => { setNewRuleAcceptable(e.target.value); markCurrentStepTouched(); }}
                 style={{
                   width:350,
                   "& .MuiOutlinedInput-root": { height: 40, width : 500 },
                 }}
               />
                  }
                  
                </Box>

                <Button
                  variant="contained"
                  
                  size="medium"
                  onClick={handleAddRule}
                  className={classes.actionButton}
                >
                  Add Rule
                </Button>
              </Box>

              <Box mt={3}>
                {rules.length === 0 ? (
                  <Box mt={2} className={classes.tablePlaceholder}>
                    No rules added
                  </Box>
                ) : (
                  <Table size="small" style={{ marginTop: 12, background: "#fff" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.boldCell}>Field</TableCell>
                        <TableCell className={classes.boldCell}>Constraint</TableCell>
                        <TableCell className={classes.boldCell}>Acceptable Value</TableCell>
                        <TableCell className={classes.boldCell} align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rules.map((r) => (
                        <TableRow key={r.id}>
                          <TableCell>{r.field}</TableCell>
                          <TableCell>{r.constraintType}</TableCell>
                          <TableCell>{formatAcceptableValue(r.acceptableValue)}</TableCell>
                          <TableCell align="right">
                            <IconButton onClick={() => handleRemoveRule(r.id)} size="small">
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </Box>
            </Box>
            </div>
          </>
        );

      case 1:
        return (
          <>
            <Box
                sx={{
                  backgroundColor: "#99CCDF",
                  padding: "8px 16px",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
              <Typography
                variant="h5"
                className={classes.sectionHeader}
              >
                Mandatory Fields
              </Typography>
            </Box>
            <div style={{padding: 20}}>

            <Box style={{display:"flex", gap: 50, alignItems:"center"}}>
                <Typography className={classes.sectionTitle} variant="h6">
                  Selected Fields
                </Typography>

                {/* Search bar */}
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search Field"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: 350,
                    "& .MuiOutlinedInput-root": {
                      height: "40px",           // controls the field height
                      fontSize: "1rem",         // match typography size
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",      // makes vertical centering look natural
                    },
                  }}
                  
                  InputProps={{
                    style: { backgroundColor: "#fff" },
                  }}
                />
            </Box>

            <Box mt={2} style={{ overflowY: "auto", maxHeight: 400 }}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.whiteRow}>
                    <TableCell className={classes.boldCell} style={{ width: 300 }}>Field Name</TableCell>
                    <TableCell className={classes.boldCell}>Mandatory</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredFields.map((field, index) => (
                    <TableRow className={index%2==0 ? classes.coloredRow :classes.whiteRow} 
                      key={field.id}
                    >
                      <TableCell className={classes.cell} style={{ width: 300 }}>{field.name}</TableCell>
                      <TableCell className={classes.cell} >
                        <Checkbox
                          size="small"
                          className={classes.checkBox}
                          checked={mandatoryFields.includes(field.name)}
                          onChange={() => handleCheckboxChange(field.name)}
                          color="primary"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>

                  
            </div>
          </>
        );

      case 2:
        return (
          <>
            <Box
                sx={{
                  backgroundColor: "#99CCDF",
                  padding: "8px 16px",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
              <Typography
                variant="h5"
                className={classes.sectionHeader}
              >
                Advanced (optional)
              </Typography>
            </Box>
            <div style={{padding: 20}}>

            <Typography className={classes.sectionTitle} variant="h6">
                  Renaming Rules
            </Typography>

            {/* Checkbox */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={enableRename}
                  onChange={handleToggleRename}
                  color="primary"
                />
              }
              label="Enable Rename"
            />

            <Box className={classes.fieldGroup}>
                {[1, 2, 3, 4, 5].map((i) => (
                  <Box>
                  <Typography className={classes.labelAbove}>Field {i}</Typography>

                  <Autocomplete
                    disabled={!enableRename}
                    options={clientFields}
                    getOptionLabel={(option) => option.name}
                    value={clientFields.find((f) => f.name === additionalFields[`field${i}`]) || null}
                    onChange={(event, newValue) => handleChange(`field${i}`, newValue ? newValue.name : "")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="Select Field"
                        style={{
                          "& .MuiOutlinedInput-root": { height: 40, width : 500 },
                        }}
                      />
                    )}
                    style={{width: 400}}
                  />
                  </Box>
                  
                ))}
              </Box>

              <Box>
                  <Typography className={classes.labelAbove}>Connector</Typography>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: 400,
                      "& .MuiOutlinedInput-root": { height: 40 , width : 100},
                    }}
                  >
                    <Select
                      disabled={!enableRename}
                      value={additionalFields.connector}
                      onChange={(e) => handleChange("connector", e.target.value)}
                      placeholder="None"
                      displayEmpty
                    >
                      {["-", "_", " "].map((opt) => (
                          <MenuItem key={opt} value={opt}>
                            {opt}
                          </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
              </Box>

              <Typography className={classes.sectionTitle} style = {{marginTop: 40}} variant="h6">
                Document Expiry
              </Typography>

              <Box>
                  <Typography className={classes.labelAbove}>Timeline (years)</Typography>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: 400,
                      "& .MuiOutlinedInput-root": { height: 40 , width : 100},
                    }}
                  >
                    <Select
                      value={additionalFields.expiry}
                      onChange={(e) => handleChange("expiry", e.target.value)}
                      placeholder="None"
                      displayEmpty
                    >
                      {[1, 2, 3, 4, 5].map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
              </Box>

              {/* Scanning Rules Section */}
              <Typography className={classes.sectionTitle} style={{ marginTop: 40 }} variant="h6">
                Scanning Rules for Document Uploads
              </Typography>

              <Box display="flex" flexDirection="row" alignItems="flex-start" style={{ gap: 24 }}>
                <FormControlLabel
                  style={{ display: 'flex', marginLeft: 0 }}
                  control={
                    <Checkbox
                      checked={scanForDuplicates}
                      onChange={(e) => setScanForDuplicates(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={<span className={classes.checkboxLabel}>Show warning for duplicate file</span>}
                />
                
                <FormControlLabel
                  style={{ display: 'flex', marginLeft: 0 }}
                  control={
                    <Checkbox
                      checked={scanForSameName}
                      onChange={(e) => setScanForSameName(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={<span className={classes.checkboxLabel}>Show warning for same file name</span>}
                />
                
                <FormControlLabel
                  style={{ display: 'flex', marginLeft: 0 }}
                  control={
                    <Checkbox
                      checked={scanForAntivirus}
                      disabled
                      color="primary"
                    />
                  }
                  label={<span className={classes.checkboxLabel}>Scan for antivirus</span>}
                />
              </Box>

              {/* Document Sharing Section */}
              <Typography className={classes.sectionTitle} style={{ marginTop: 40 }} variant="h6">
                Document Sharing
              </Typography>

              <Box>
                <Typography className={classes.labelAbove}>Link Expiry</Typography>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: 400 }}
                >
                  <Select
                    value={shareLinkExpiryMinutes}
                    onChange={(e) => setShareLinkExpiryMinutes(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value={60}>60 minutes</MenuItem>
                    <MenuItem value={45}>45 minutes</MenuItem>
                    <MenuItem value={30}>30 minutes</MenuItem>
                    <MenuItem value={15}>15 minutes</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Typography className={classes.sectionTitle} style = {{marginTop: 40}} variant="h6">
                Share Folder
              </Typography>
            </div>
          </>
        );

      case 3:
        return (
          <>
            <Box
                sx={{
                  backgroundColor: "#99CCDF",
                  padding: "8px 16px",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              >
              <Typography
                variant="h5"
                className={classes.sectionHeader}
              >
                Review & Submit
              </Typography>
            </Box>
            <div style={{padding: 20}}>

            <Box
                sx={{
                  backgroundColor: "#E3F2FD", // blue shade
                  padding: "8px 16px"
                }}
              >
              <Typography
                variant="h6"
                className={classes.sectionHeader}
              >
                Details
              </Typography>
            </Box>

            <div style={{paddingLeft:10}}>

            

            <Typography className={classes.sectionTitle} style={{marginTop: 10}} variant="h6">
              Basic Details
            </Typography>

            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
              <Box style={{width:400}}>
                <Typography className={classes.labelAbove}>Name*</Typography>
                <Typography className={classes.sectionTitle2} variant="h7">
                  {name}
                </Typography>
              </Box>

              <Box>
                <Typography className={classes.labelAbove}>Description</Typography>
                <Typography className={classes.sectionTitle2} variant="h7">
                  {description}
                </Typography>
              </Box>
            </Box>

            <Typography className={classes.sectionTitle} style={{marginTop: 20}} variant="h6">
              Folder Rules
            </Typography>

            <Box>
              <Box mt={3}>
                {rules.length === 0 ? (
                  <Box mt={2} className={classes.tablePlaceholder}>
                    No rules added
                  </Box>
                ) : (
                  <Table size="small" style={{ marginTop: 12, background: "#fff" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.boldCell}>Field</TableCell>
                        <TableCell className={classes.boldCell}>Constraint</TableCell>
                        <TableCell className={classes.boldCell}>Acceptable Value</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rules.map((r) => (
                        <TableRow key={r.id}>
                          <TableCell>{r.field}</TableCell>
                          <TableCell>{r.constraintType}</TableCell>
                          <TableCell>{formatAcceptableValue(r.acceptableValue)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </Box>
            </Box>
            </div>

            <Box
                sx={{
                  backgroundColor: "#E3F2FD", // blue shade
                  padding: "8px 16px",
                  marginTop: 30
                }}
              >
              <Typography
                variant="h6"
                className={classes.sectionHeader}
              >
                Mandatory fields
              </Typography>
            </Box>

            <div style={{paddingLeft:10}}>

            <Box mt={2} style={{ overflowY: "auto", maxHeight: 400 }}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.whiteRow}>
                    <TableCell className={classes.boldCell} style={{ width: 300 }}>Field Name</TableCell>
                    <TableCell className={classes.boldCell}>Mandatory</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mandatoryFields.map((field, index) => (
                    <TableRow className={index%2==0 ? classes.coloredRow :classes.whiteRow} 
                      key={index}
                    >
                      <TableCell className={classes.cell} style={{ width: 300 }}>{field}</TableCell>
                      <TableCell className={classes.cell} >
                        <Checkbox
                          size="small"
                          className={classes.checkBox}
                          checked={true}
                          color="primary"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>

            </div>

            <Box
                sx={{
                  backgroundColor: "#E3F2FD", // blue shade
                  padding: "8px 16px",
                  marginTop: 30
                }}
              >
              <Typography
                variant="h6"
                className={classes.sectionHeader}
              >
                Advanced
              </Typography>
            </Box>

            <div style={{paddingLeft:10}}>

            <Typography className={classes.sectionTitle} style={{marginTop: 10}} variant="h6">
              Renaming Rules
            </Typography>

            <Box className={classes.fieldGroup}>
                {[1, 2, 3, 4, 5].map((i) => (
                  <Box style={{width:400}}>
                      <Typography className={classes.labelAbove}>Field {i}</Typography>
                      <Typography className={classes.sectionTitle2} variant="h7">
                        {additionalFields[`field${i}`]}
                      </Typography>
                  </Box>
                  
                ))}

                <Box>
                  <Typography className={classes.labelAbove}>Connector</Typography>
                  <Typography className={classes.sectionTitle2} variant="h7">
                          {additionalFields.connector}
                  </Typography>
                </Box>
              </Box>


            <Typography className={classes.sectionTitle} style = {{marginTop: 20}} variant="h6">
                Document Expiry
            </Typography>

            <Box>
                  <Typography className={classes.labelAbove}>Timeline (years)</Typography>
                  <Typography className={classes.sectionTitle2} variant="h7">
                          {additionalFields.expiry}
                  </Typography>
                </Box>
            </div>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  const fetchClientFields = ()=>{
    DocuwareTemplateService.getClientFields().then(response => {
        let clientFieldResponse = response.data;
        // Filter out alias fields (fields with parentFieldId) - only show canonical fields
        clientFieldResponse = clientFieldResponse.filter(field => 
          !field.parentFieldId && !field.parent_field_id
        );
        setClientFields(clientFieldResponse);
      }).catch(error => {
        notify({
          type: 'error',
          message: 'Error fetching the field columns'
        });
    })
  }

  const setScanForAntivirusStatus = ()=>{
    DocuwareTemplateService.getAntivirusSettings().then(response => {
      let antivirusResponse = response.data;
      antivirusResponse = antivirusResponse ? antivirusResponse.enableAntivirusFileScanDuringUpload : true;
      setScanForAntivirus(antivirusResponse);
    }).catch(error => {
      setScanForAntivirus(false);
  })
  }

  useEffect(() => {
    fetchClientFields();
    setScanForAntivirusStatus();
  }, [])

  return (
    <div className={classes.pageWrapper}>
    <Container maxWidth="xl" style={{ padding: '20px' }}>
          <div style={{marginBottom: '1px'}}>
            <Box className={classes.titleContainer}>
                <Box sx={{ display: 'flex', alignItems: 'center'}}>
                    <Button 
                        startIcon={<ArrowBackIcon />}
                        className={classes.backButton}
                        onClick={handleHomeClick}
                        >
                        Back to Storage
                    </Button>
                </Box>
                <Typography 
                    variant="h4" 
                    className={classes.title}
                    >
                    NEW FOLDER
                    </Typography>

            </Box>
          </div>
      <Backdrop open={backdrop} style={{ color: "#fff", zIndex: 1000000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box className={classes.stepperBox}>
          <Stepper activeStep={activeStep} alternativeLabel className={classes.customStepper} >
            {steps.map((label, index) => {
              // Incomplete: current step AND user has touched it
              const isIncomplete = index === activeStep && touchedSteps[index];
              // Completed: any step before current step
              const isCompleted = index < activeStep;
              return (
                <Step key={label} style={{ flex: 1 }} completed={isCompleted}>
                  <StepLabel 
                    StepIconComponent={CustomStepIcon}
                    StepIconProps={{ incomplete: isIncomplete }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
      </Box>

      <Paper className={classes.rootPaper} elevation={0}>
          {renderStepContent(activeStep)}

          <Box className={classes.actions}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handleBack}
              disabled={activeStep === 0}
              className={classes.smallButton}
            >
              Back
            </Button>

            <Box>
              {activeStep < steps.length - 1 && (
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon/>}
                  onClick={handleNext}
                  className={classes.smallButton}
                  disabled={activeStep === 0 && !isNameValid()}
                  style={{backgroundColor: "#00445D",
                  color: "#fff"}}
                >
                  Next
                </Button>
              )}
              {activeStep === steps.length - 1 && (
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  className={classes.smallButton}
                  style={{backgroundColor: "#00445D",
                  color: "#fff"}}
                >
                  Submit
                </Button>
              )}
            </Box>
          </Box>
      </Paper>

      {/* Error Dialog */}
      <Dialog
        open={errorDialog.open}
        onClose={closeErrorDialog}
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.errorDialogPaper }}
      >
        <DialogTitle className={classes.errorDialogTitle}>
          <Box className={classes.errorDialogTitleContent}>
            <Box className={classes.errorDialogTitleLeft}>
              <WarningIcon className={classes.errorDialogIcon} />
              <Typography className={classes.errorDialogTitleText}>
                {errorDialog.title}
              </Typography>
            </Box>
            <IconButton size="small" onClick={closeErrorDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent className={classes.errorDialogContent}>
          <Box className={classes.errorDialogMessageBox}>
            <Typography className={classes.errorDialogMessage}>
              {errorDialog.message}
            </Typography>
            {errorDialog.subMessage && (
              <Typography className={classes.errorDialogSubMessage}>
                {errorDialog.subMessage}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions className={classes.errorDialogActions}>
          <Button
            variant="contained"
            onClick={closeErrorDialog}
            className={classes.errorDialogButton}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
    </div>
  );
}
